import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { DeleteColumnRPC } from "./deleteColumnRPC";

export class DeleteColumnRPCClientImpl extends DeleteColumnRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: DeleteColumnRPC.Request): Promise<LeoRPCResult<DeleteColumnRPC.Response, DeleteColumnRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "respondent/DeleteColumn",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      DeleteColumnRPC.ResponseDTO,
      DeleteColumnRPC.Errors.ErrorsDTO,
      DeleteColumnRPC.Response,
      DeleteColumnRPC.Errors.Errors
    >(
      response,
      "respondent/DeleteColumn",
      DeleteColumnRPC.Response.fromDTO,
      DeleteColumnRPC.Errors.fromDTO
    );
  }
}
